"use strict";

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import {
    mergeMap,
    catchError,
    map,
    concatMap,
    switchMap,
} from "rxjs/operators";
import {
    getRealTimeRewardCodeComplete,
    getRealTimeRewardReasonListComplete,
    getParticipantListComplete,
    smsRealTimeRewardCodeComplete,
    homeCampaignListComplete,
    homeGetRealTimeRewardCampaignComplete,
    registerDealerParticipantComplete,
    getParticipantJobRoleComplete,
    getDealerParticipantListComplete,
    getDealerParticipantListRequest,
    ajaxError,
    homeChatbotReplyQuestionComplete,
    homeGetChatbotFaqQuestionsComplete,
    removeDealerParticipantComplete,
    updateDealerParticipantStatusComplete,
    requestActivateAccountComplete,
    homeUserLoginStatusComplete,
    homeGetTeamGamePlayDetailsComplete,
    homeResetGamePlayCodeComplete,
    homeSendGamePlayCodeComplete,
    homeGetTeamGamePlayDetailsRequest,
    homeGetNotificationComplete,
    homeDeleteNotificationComplete,
    homeGetNotificationRequest,
    homeGetNotificationCountComplete,
} from "../_actions";
import { homeConstants, requestTypes } from "../_constants";
import { getRequestHeader } from "../../_helpers/request.header";

export const homeSmsRealTimeRewardCodeEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_SMS_REALTIME_REWARD_CODE_REQUEST),
        mergeMap(({ payload, ...action }) => {
            return ajax
                .post(
                    "/api/home/sms-real-time-reward-code",
                    {
                        userId: payload.userId,
                        reasonId: payload.reasonId,
                        campaignId: payload.campaignId,
                        rewardCode: payload.rewardCode,
                    },
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        payload.form.restart();
                        return smsRealTimeRewardCodeComplete(ajaxResponse);
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeGetRealTimeRewardCampaignEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_REAL_TIME_REWARD_CAMPAIGN_REQUEST),
        mergeMap(({ payload, ...action }) => {
            return ajax
                .post(
                    "/api/home/get-real-time-reward-campaign",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return homeGetRealTimeRewardCampaignComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeGetRealTimeRewardCodeEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_REALTIME_REWARD_CODE_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    "/api/home/get-real-time-reward-code",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getRealTimeRewardCodeComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeGetRealTimeRewardReasonListEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_REALTIME_REWARD_REASON_LIST_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    "/api/home/get-real-time-reward-reason-list",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getRealTimeRewardReasonListComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeGetParticipantListEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_PARTICIPANT_LIST_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    "/api/home/get-participant-list",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getParticipantListComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeCampaignListEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_CAMPAIGN_LIST_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    "/api/home/campaign-list",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return homeCampaignListComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeGetChatBotReplyQuestionEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_CHATBOT_REPLY_QUESTION_REQUEST),
        mergeMap(({ payload, ...action }) => {
            return ajax
                .post(
                    "/api/home/get-chatbot-reply-question",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return homeChatbotReplyQuestionComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getParticipantJobRoleEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.GET_PARTICIPANT_JOB_ROLES_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    "/api/home/participant-job-roles",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getParticipantJobRoleComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeGetChatbotFaqQuestionsEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_CHATBOT_FAQ_QUESTIONS_REQUEST),
        mergeMap(({ payload, ...action }) => {
            return ajax
                .post(
                    "/api/home/get-chatbot-faq-questions",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return homeGetChatbotFaqQuestionsComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getDealerParticipantListEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.GET_DEALER_PARTICIPANT_LIST_REQUEST),
        mergeMap(({ payload, ...action }) => {
            return ajax
                .post(
                    "/api/home/get-dealer-participants",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getDealerParticipantListComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const registerDealerParticipantEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.REGISTER_DEALER_PARTICIPANT_REQUEST),
        mergeMap((action) => {
            const { formRestart, ...payload } = action.payload;
            return ajax
                .post(
                    "/api/home/register-dealer-participants",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        formRestart();
                        return of(
                            getDealerParticipantListRequest({
                                dealerCode: payload.dealerCode
                            }),
                            registerDealerParticipantComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),

                    catchError((error) =>
                        of(ajaxError(error)).pipe(
                            concatMap((failureAction) =>
                                of(
                                    failureAction,
                                    getDealerParticipantListRequest(),
                                ),
                            ),
                        ),
                    ),
                );
        }),
    );
};

export const removeDealerParticipantEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.REMOVE_DEALER_PARTICIPANT_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/remove-dealer-participant",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            getDealerParticipantListRequest({
                                dealerCode: payload.dealerCode
                            }),
                            removeDealerParticipantComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const updateDealerParticipantStatusEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.UPDATE_DEALER_PARTICIPANT_STATUS_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/update-dealer-participant-status",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            getDealerParticipantListRequest({
                                dealerCode: payload.dealerCode
                            }),
                            updateDealerParticipantStatusComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const requestActivateAccountEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.SEND_ACTIVATE_ACCOUNT_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/request-activate-account",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )

                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            getDealerParticipantListRequest({
                                dealerCode: payload.dealerCode
                            }),
                            requestActivateAccountComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeUserLoginStatusEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_USER_LOGIN_STATUS_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/user-login-status",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(

                            homeUserLoginStatusComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getTeamGamePlayDetailsEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_TEAM_GAME_PLAY_DETAILS_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/get-team-game-play-details",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(

                            homeGetTeamGamePlayDetailsComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeSendGamePlayCodeEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_TEAM_SEND_GAME_PLAY_CODE_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/team-send-play-code",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            homeGetTeamGamePlayDetailsRequest({}),
                            homeSendGamePlayCodeComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeResetGamePlayCodeEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_TEAM_RESET_GAME_PLAY_CODE_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/team-reset-play-code",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            homeGetTeamGamePlayDetailsRequest({}),
                            homeResetGamePlayCodeComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeGetNotificationEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            homeConstants.HOME_GET_NOTIFICATIONS_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/home/get-notification",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            homeGetNotificationComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeDeleteNotificationEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_DELETE_NOTIFICATIONS_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/delete-notification",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            homeGetNotificationRequest({}),
                            homeDeleteNotificationComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const homeGetNotificationCountEpic = (actions$) => {
    return actions$.pipe(
        ofType(homeConstants.HOME_GET_NOTIFICATION_COUNT_REQUEST),
        mergeMap((action) => {
            const { ...payload } = action.payload;

            return ajax
                .post(
                    "/api/home/get-notification-count",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            homeGetNotificationCountComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};







